const getIsAvailableForInstoreSubscription = (serverVariant, purchaseTypePrices)=>{
    const hasAvailableForInstoreSubscriptionAttribute = !!serverVariant.isAvailableForInStoreSubscription;
    const hasInstoreSubscriptionPrice = !!purchaseTypePrices['instore-subscription-purchase'];
    if (hasAvailableForInstoreSubscriptionAttribute && !hasInstoreSubscriptionPrice) {
        console.error(`Product is available for instore subscription, but has no instore subscription price. sku: ${serverVariant.sku} name: ${serverVariant.displayName}`);
        return false;
    }
    return hasAvailableForInstoreSubscriptionAttribute;
};

export { getIsAvailableForInstoreSubscription };
//# sourceMappingURL=get-is-available-for-instore-subscription.js.map
